const carpayNoFeesRoute = '/carpay/orders/no-fees'

export default carpayNoFeesRoute
